/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/* tslint:disable */

module DealerwareWebContent {

    "use strict";

    export class SettingsWebhooksController {

        public static $inject : string[ ] = [ ];

        public loading: boolean = true;


        constructor(

        ) {

            this.loading = false;
        }

    }

    getDealerwareWebContentModule().controller(
        'SettingsWebhooksController',
        SettingsWebhooksController
    );
}

